import { lazy, Suspense } from "react";
import { RetreatBridge } from "./components/RetreatBridge";
import { LegacyRetreatBridge } from "./components/LegacyRetreatBridge";
import { AuthGate } from "./auth/AuthGate";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { E2E_HARNESS_UI_KEY } from "./testing/testIds";

// Lazy-load dev tools so they're tree-shaken from the prod bundle
const BellDemoScreen = lazy(() =>
  import("./screens/BellDemoScreen").then((m) => ({
    default: m.BellDemoScreen,
  })),
);

function LegacyBridgeWrapper() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-blue-600 flex items-center justify-center p-8">
      <LegacyRetreatBridge />
    </div>
  );
}

export default function App() {
  const pathname = window.location.pathname;
  const uiParam = new URLSearchParams(window.location.search).get("ui");

  // Internal bell library audition — /bell-demo
  if (pathname === "/bell-demo") {
    return (
      <Suspense fallback={null}>
        <BellDemoScreen />
      </Suspense>
    );
  }

  // Demo bypasses auth gate — only available in local dev and E2E test runs.
  // In deployed builds (CloudFront) this route redirects to home so it can't
  // be used to bypass the paywall.
  if (pathname === "/demo") {
    const isE2E = !!(window as unknown as Record<string, unknown>).__E2E_MODE__;
    if (!import.meta.env.DEV && !isE2E) {
      window.location.replace("/");
      return null;
    }
    return (
      <ErrorBoundary>
        <RetreatBridge demo />
      </ErrorBoundary>
    );
  }

  // Test engine route — auto-starts 5min retreat
  if (pathname === "/test-engine") {
    return (
      <ErrorBoundary>
        <RetreatBridge demo testEngine />
      </ErrorBoundary>
    );
  }

  // TODO: retire LegacyRetreatBridge and migrate arch-zombie-session.spec.ts +
  // session-auto-complete.spec.ts to the /demo route before removing this branch.
  // LegacyRetreatBridge is a minimal engine test harness (two-button Begin/Complete UI,
  // no auth) used by those E2E suites. It is never shown to production users.
  if (uiParam === E2E_HARNESS_UI_KEY) {
    return <LegacyBridgeWrapper />;
  }

  // m2 is the default
  return (
    <ErrorBoundary>
      <AuthGate>
        <RetreatBridge />
      </AuthGate>
    </ErrorBoundary>
  );
}
